var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPhase(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 138,
    height: 82,
    viewBox: "0 0 138 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4231_4038)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41 1.04867L10 32.0487C4 25.6487 0.833333 29.7153 0 32.5486V54.5486C5.5 54.5486 17.7 54.4486 22.5 54.0486C27.7 51.2486 24.6667 45.882 22.5 43.5486C30.1667 36.0486 47.1 19.1487 53.5 11.5487C54.3 -0.0513287 44.5 -1.45141 41 1.04867Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.5462 1.09731L127.546 32.0973C133.546 25.6973 136.713 29.764 137.546 32.5973V54.5973C132.046 54.5973 119.846 54.4973 115.046 54.0973C109.846 51.2973 112.88 45.9306 115.046 43.5973C107.38 36.0973 90.4462 19.1973 84.0462 11.5973C83.2462 -0.00269127 93.0462 -1.40277 96.5462 1.09731Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.7329 15.6617V59.5023C50.9648 59.2195 51.6012 64.3342 53.0154 66.9269L68.5717 82.4833C72.4608 78.5942 81.0168 69.8968 84.1281 66.2198C85.8251 60.563 79.8854 58.913 76.7034 58.7952C76.8213 48.0707 76.8449 24.147 75.9964 14.2475C68.3596 5.47936 60.4399 11.419 59.7329 15.6617Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4231_4038"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 138,
    height: 82,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhase);
export default __webpack_public_path__ + "static/media/Phase.9765ce23fd21b0b6a464980695e81430.svg";
export { ForwardRef as ReactComponent };